module.exports = __webpack_public_path__ + "static/media/app-store-download.381dbd5b.svg";